import { z } from 'zod';
import { mongoId } from '../utils/basicSchemas/_id.z.schema';
import { ZSchema } from '../utils/zodSchema';

const donationSchema = z.object({
    eventType: z.enum(
        ["Garden Sale", "Mint", "Originated"],
        { invalid_type_error: "Event type is invalid" }
    ),
    transactionAmount: z.number().nonnegative("Amount must be 0 or larger"),
});
const donationIdSchema = z.object({
    id: mongoId("Donation id"),
});

const donationValidator = new ZSchema({
    bodySchema: donationSchema,
    paramSchema: donationIdSchema
});
const donationIdValidator = new ZSchema({
    paramSchema: donationIdSchema
});

export { donationValidator, donationIdValidator };
